// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SideNav_wrapper__1k2vr","show":"SideNav_show__1A91W","active":"SideNav_active__2Kb_X"};